import {
  KissanEventType,
  updateFollowStatusApi,
  useAppPersistenceStore,
  useGlobalLoginContext,
  useProfileStore,
} from '@ninjacart/nc-nk-store';
import {
  AskQuestionFlotingIcon,
  Card,
  CustomPressable,
  NoSearchResult,
  Paragraph,
  Separator,
  Spinner,
  Text,
  UIBottomSheet,
  useTheme,
  View,
  YStack,
} from '@ninjacart/nc-nk-ui';
import { FlashList, ViewToken } from '@shopify/flash-list';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FloatingAction } from 'react-native-floating-action';
import { AnimatedQuestionAnswerHeader } from './animatedQuestionAnswerHeader';
import { AnsweredCard } from './answeredCard';
// import { Animated, Easing, ImageSourcePropType } from 'react-native';
import { AskQuestionCtaCard } from './askQuestionCtaCard';
import { MyQuestionStatusCard } from './myQuestionStatusCard';
import { QnAPlaceHolder } from './qnaPlaceholder';

import {
  addEventParam,
  INinjaEvent,
  useQueuedEventStore,
} from '@ninjacart/nc-events-sdk-v2';
import { BaseAdaptiveCardRenderer } from '@ninjacart/nc-nk-adaptive-cards';
import {
  IActionDataModel,
  IAdaptiveActionCard,
  IQnAListPayload,
  IQuestionAnswer,
  safeStringify,
} from '@ninjacart/nc-nk-core';
import { useFeatureFlag } from '@ninjacart/nc-nk-ff4j';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import { Dimensions, LayoutRectangle, Platform } from 'react-native';
import { getAllQnAList, getUserQnAList } from '../../api/kisan/getAllQnAList';
import { useQnaFeedStore } from '../../store/useQnaStore';
import { LanguageButton } from './languageButton';
import { LanguageFilter } from './languageFilter';
import RenderProgressBar from './renderVideoProgressBar';

export const QuestionAnswerList = () => {
  const userProfile = useProfileStore((state) => state.userProfile);
  const startCountRef = useRef({ page: 0, limit: 10 });
  const [onEndReachedSpinner, setOnEndReachedSpinner] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [isScrolled, setScrolled] = useState(false);
  const CONTAINER_HEIGHT = 90;
  const qnaFeedStore = useQnaFeedStore();
  const showTimer = useQnaFeedStore((state) => state.showTimer);
  const setShowTimer = useQnaFeedStore((state) => state.setShowTimer);
  const setUserQnaFeed = useQnaFeedStore((state) => state.setUserQnaFeed);
  const questionActiveTimerList = useQnaFeedStore((state) => state.questionActiveTimerList);
  const setQuestionActiveTimerList = useQnaFeedStore((state) => state.setQuestionActiveTimerList);
  const expertAnswerImmediate = useQnaFeedStore((state) => state.expertAnswerImmediate);
  const userQnaFeed = qnaFeedStore.userQnaFeed;
  const allQnAList = useQnaFeedStore((state) => state.qnaFeed);
  const setAllQnAList = useQnaFeedStore((state) => state.setQnaFeed);
  const [refreshTs, setRefreshTs] = useState(Date.now());
  // const [assets, error] = useAssets([require('../../../../apps/mobile/assets/image/sorry.png')]);

  const [visibleItemIndex, setVisibleItemIndex] = useState<number | null>(null);
  const [questionId, setQuestionId] = useState('');
  const flashListRef = useRef<FlashList<
    IAdaptiveActionCard<IActionDataModel<IQuestionAnswer>>
  > | null>(null);
  const [needRefresh, setNeedRefresh] = useState<boolean>(false);
  const deviceWidth = Dimensions.get('window').width;
  const theme = useTheme();
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;
  const uniqueDeviceId = useAppPersistenceStore((state) => state.deviceId);
  const requestQnAFeatureFlow = useFeatureFlag(
    'requestQnAFeatureFlow',
    'UserDeviceId',
    uniqueDeviceId!
  );

  const [qnaNewFlow, setQnaNewFlow] = useState({
    name: requestQnAFeatureFlow ? '/askQuestionSearch' : '/qna/create',
    routeName: requestQnAFeatureFlow ? 'askQuestionSearch/index' : 'qna/create/index',
    translate: `${t('page.askQuestionCtaQnaPage')}`,
    description: 'QNA page',
  });
  const [langaugeBottomSheet, setLangaugeBottomSheet] = useState<boolean>(false);
  const appLanguage = useAppPersistenceStore((state) => state.appLanguage);
  const setLanguageFilterValue = useQnaFeedStore((state) => state.setLanguageFilterValue);
  const languageFilterValue = useQnaFeedStore((state) => state.languageFilterValue);
  const fields = useGlobalLoginContext(['openLoginSheet','previousPage', 'navigationParams']);
  const setNavigationParams = fields.navigationParams.set;
  const { push } = useRouter();
  const hasUserLoggedIn = useProfileStore((state) => state.hasUserLoggedIn);
  const [layout, setLayout] = useState<LayoutRectangle | null>(null);

  // useScrollToTop(
  //   useRef({
  //     scrollToTop: () =>
  //       flashListRef.current?.scrollToOffset({
  //         animated: true,
  //         offset: 0,
  //       }),
  //   })
  // );

  useEffect(() => {
    setLanguageFilterValue(appLanguage!);
    startCountRef.current.page = 1;
    initializeQnAList();
    initializeUserQnAList();
  }, []);

  const handleScroll = (event) => {
    const { y } = event.nativeEvent.contentOffset;
    const scrolled = y > 1;
    if (scrolled) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    if (refreshing) {
      startCountRef.current.page = 1;
      initializeQnAList();
      initializeUserQnAList();
    }
  }, [refreshing]);

  const initializeUserQnAList = async () => {
    try {
      if (!userProfile?.user) {
        console.log('User not logged in. Skipping my questions api');
        return;
      }

      const payload: IQnAListPayload = {
        userId: userProfile?.user?.id ?? '1',
        realmId: userProfile?.realm?.id ?? '1',
        limit: startCountRef?.current?.limit,
        page: startCountRef.current.page,
        desc: true,
        includeReplies: true,
        tags: languageFilterValue ? `system_${languageFilterValue}` : `system_${appLanguage}`,
      };
      const userQnaList = await getUserQnAList(payload);
      setUserQnaFeed(userQnaList);
      console.log('On refresh re-trigger timers!!!');
      setQuestionActiveTimerList();
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    console.log('Changing refresh timestamp!!!');
    setRefreshTs(Date.now());
  }, [userQnaFeed, needRefresh]);

  const navigateToCreateQuestion = () => {
    const qnaAskQuestionClickEvent: INinjaEvent = {
      name: KissanEventType.QNA_ASKQUES_CLICK,
      screenDetails: { screen: 'qna page' },
      eventParams: [
        addEventParam('floatingIconAskQuestionClicked', 'Floating Icon Ask Question Clicked'),
      ],
    };
    enqueue(qnaAskQuestionClickEvent);
    if (!hasUserLoggedIn()) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set(qnaNewFlow?.description);
      setNavigationParams({
        name: qnaNewFlow?.name,
        routeName: { name: qnaNewFlow?.routeName },
        description: qnaNewFlow?.translate,
        screenName: qnaNewFlow?.description,
      });
    } else {
      push(qnaNewFlow?.name);
    }
  };

  const initializeQnAList = async () => {
    console.log('Is refreshing => ', refreshing);
    try {
      /**
       * TODO: below condition is an workaround.
       * This needs to be fixed from the api.
       * API returns 3 elems in 0th page as well as 1st page
       */
      // if (allQnAList?.length % startCountRef?.current?.limit !== 0 && !refreshing) {
      //   return;
      // }

      const payload: IQnAListPayload = {
        userId: userProfile?.user?.id ?? '1',
        realmId: userProfile?.realm?.id ?? '1',
        limit: startCountRef?.current?.limit,
        page: startCountRef.current.page,
        desc: true,
        includeReplies: true,
        tags: languageFilterValue ? `system_${languageFilterValue}` : `system_${appLanguage}`,
      };

      console.log('Non logged in user payloiad => ', payload);

      const qnaList = await getAllQnAList(payload);
      if (qnaList?.length === 0) return;

      if (refreshing) {
        console.log('Resetting list', qnaList?.length);
        setAllQnAList(qnaList);
        startCountRef.current.page++;
        return qnaList;
      }

      const mergeFeeds = [...allQnAList, ...qnaList];
      console.log('Qna list length => ', mergeFeeds?.length);
      setAllQnAList([...allQnAList, ...qnaList]);
      startCountRef.current.page++;
      return qnaList;
    } catch (error) {
      console.log('All QnA List Error', error);
    } finally {
      setLoading(false);
      setRefreshing(false);
      console.log('Loading completed. Ready for view!!!');
    }
  };

  const onNextPageLoadEvent = () => {
    if (allQnAList?.length >= 5) {
      const qnaVerticalScrollEvent: INinjaEvent = {
        name: KissanEventType.QNA_PAGESCROLL_VERTICAL_START,
        screenDetails: { screen: 'qna page' },
        eventParams: [addEventParam('activeIndex', allQnAList?.length)],
      };
      enqueue(qnaVerticalScrollEvent);
    }
  };

  const onNextPageLoadFailEvent = (error) => {
    const qnaVerticalScrollFailedEvent: INinjaEvent = {
      name: KissanEventType.QNA_PAGESCROLL_VERTICAL_FAIL,
      screenDetails: { screen: 'qna page' },
      eventParams: [
        addEventParam('errorMessage', error.toString()),
        addEventParam('apiError', safeStringify(error)),
      ],
    };
    enqueue(qnaVerticalScrollFailedEvent);
  };

  const onEndReached = async () => {
    try {
      onNextPageLoadEvent();
      console.log('Qna List on end reached callback!!!');
      setOnEndReachedSpinner(true);
      await initializeQnAList();
    } catch (error) {
      onNextPageLoadFailEvent(error);
      console.error('On End reachred All QnA err => ', error);
    } finally {
      setOnEndReachedSpinner(false);
    }
  };

  const renderQnAListItem = ({
    item,
    index,
  }: {
    item: IAdaptiveActionCard<IActionDataModel<IQuestionAnswer>>;
    index: number;
  }) => {
    const commonProps = {
      item: item?.actionData?.content,
      index,
      deviceWidth,
      itemKey: item?.actionData?.content?.itemKey ?? index.toString(),
      unitId: item?.actionData?.content?.unitId!,
      bannerAdKeywords: item?.actionData?.content?.tags ?? [],
      showFeedbackOnReplies: false,
      showFollowOnCard:
        item?.actionData?.content?.author?.creatorid === userProfile?.user?.id ? false : true,
      updateConnectionStatus,
      sourcePage: 'QNA Page',
      screenName: 'qna page',
      name: item.type!,
      useQnaFeedStore: useQnaFeedStore,
    };
    return (
      <View flex={1}>
        <BaseAdaptiveCardRenderer {...commonProps} />
      </View>
    );
  };

  const myQnAListEmptyComponent = () => {
    return (
      <YStack
        backgroundColor={'$light'}
        justifyContent="center"
        alignItems="center"
        padding={16}
        marginVertical={20}
        borderRadius={50}
        marginTop={100}
      >
        {/* <Image
          source={{ uri: 'https://tecxsprts3.s3.amazonaws.com/1718971160101-sorry.png' }}
          height={100}
          width={'100%'}
        /> */}
        <NoSearchResult height={100} width={'100%'} />
        <Paragraph
          fontSize={22}
          fontWeight={'600'}
          color={'$color'}
          marginTop={20}
          marginBottom={10}
        >
          {t('page.noQuestionYet')}
        </Paragraph>
      </YStack>
    );
  };

  const onPullToRefresh = async () => {
    setLoading(true);
    console.log('On refresh called!!!');
    setRefreshing(true);
  };
  const onOpenLanguageFilter = () => {
    setLangaugeBottomSheet(true);
  };
  const handleFilterChange = (value) => {
    setLanguageFilterValue(value);
    setLoading(true);
    setRefreshing(true);
  };

  const listHeaderComponent = () => {
    return (
      <YStack backgroundColor={'$background'}>
        <AskQuestionCtaCard />
        <RenderProgressBar />
        {expertAnswerImmediate?.actionData?.content && (
          <AnsweredCard item={expertAnswerImmediate?.actionData?.content} />
        )}
        <Paragraph
          marginHorizontal={10}
          marginVertical={4}
          fontSize={18}
          color={'$color'}
          fontWeight={600}
        >
          {t('page.allQuestions')}
        </Paragraph>
        <LanguageButton theme={theme} onOpenLanguageFilter={onOpenLanguageFilter} t={t} />
        {questionActiveTimerList?.length > 0 && (
          <Card
            shadowColor={'#000000'}
            shadowRadius={5}
            elevation={5}
            marginHorizontal={3}
            shadowOpacity={0.2}
            marginVertical={10}
            backgroundColor="$cardbackground"
            padding={10}
          >
            <MyQuestionStatusCard item={questionActiveTimerList[0]?.actionData?.content} />
          </Card>
        )}
      </YStack>
    );
  };

  // const navigateToLoginPage = () => {
  //   setGuessUserBottomSheet(false);

  //   push(`/login`);
  // };

  const viewabilityConfig = {
    itemVisiblePercentThreshold: 50,
    minimumViewTime: 1000,
  };

  const captureImpressionEvent = (index: number, itemId: number | undefined, type: string) => {
    const dataViewedMoreThanOneSecEvent: INinjaEvent = {
      name: KissanEventType.DATA_VIEWED_MORETHAN_ONE_SECOND,
      screenDetails: { screen: 'qna page' },
      eventParams: [
        addEventParam('scrolledIndex', index),
        addEventParam('itemId', itemId),
        addEventParam('type', type),
      ],
    };
    enqueue(dataViewedMoreThanOneSecEvent);
    // console.log(`Impression event for item at index ${index} in QnA`);
  };

  const viewableItemsChanged = useCallback(
    ({ viewableItems }: { viewableItems: ViewToken[] }) => {
      if (viewableItems?.length > 1) {
        viewableItems.forEach((item) => {
          const index = item.index;
          const itemId = item?.item?.actionData?.content?.id;
          const type = item?.item?.type;
          if (index) {
            setVisibleItemIndex(index);
            captureImpressionEvent(index, itemId, type);
          }
        });
      }
    },
    [visibleItemIndex, userProfile]
  );

  if (loading) {
    return <QnAPlaceHolder showDetailPage={true} />;
  }

  const updateFollowState = (prevState, authorId) => {
    return allQnAList?.map((el) => {
      if (el?.actionData?.content?.author?.creatorid === authorId) {
        return {
          ...el,
          actionData: {
            ...el.actionData,
            content: {
              ...el.actionData.content,
              following: !prevState,
            },
          },
        };
      }
      return el;
    });
  };

  const updateConnectionStatus = async (isFollow: boolean, authorId: string) => {
    const prevState = isFollow;

    const updatedQNAList = updateFollowState(prevState, authorId);
    setAllQnAList(updatedQNAList);

    try {
      const config = {
        type: isFollow ? 'unfollow' : 'follow',
        formData: {
          sourceObjectId: userProfile?.user?.id ?? '-1',
          sourceObjectType: 'USER',
          destinationObjectId: authorId,
          destinationObjectType: 'USER',
          associationType: 'FOLLOWED',
        },
      };

      const response: boolean = await updateFollowStatusApi(config);
      if (!response) {
        const updatedQNAList = updateFollowState(response ? prevState : !prevState, authorId);
        setAllQnAList(updatedQNAList);
      }
    } catch (error) {
      console.error('Error updating Connection Status', error);
      const updatedQNAList = updateFollowState(!prevState, authorId);
      setAllQnAList(updatedQNAList);
    } finally {
      setNeedRefresh(!needRefresh);
    }
  };

  return (
    <YStack
      fullscreen
      // justifyContent="flex-start"
      backgroundColor={theme['background']?.val}
      onLayout={(e) => {
        // console.log('Layout size => ', e.nativeEvent.layout);
        setLayout(e.nativeEvent.layout);
      }}
    >
      <AnimatedQuestionAnswerHeader
      // animatedValue={headerTranslate}
      // height={CONTAINER_HEIGHT}
      // opacity={opacity}
      // isScrolled={isScrolled}
      />

      {layout && (
        <FlashList
          ref={flashListRef}
          data={allQnAList}
          // contentContainerStyle={{ paddingTop: 12 }}
          renderItem={renderQnAListItem}
          keyExtractor={(item, index) => {
            return `${item?.actionData?.content?.id}-${index}`;
          }}
          scrollEventThrottle={24}
          ListEmptyComponent={myQnAListEmptyComponent}
          ListHeaderComponent={listHeaderComponent()}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          estimatedItemSize={370}
          numColumns={1}
          extraData={refreshTs}
          viewabilityConfig={viewabilityConfig}
          onViewableItemsChanged={viewableItemsChanged}
          refreshing={refreshing}
          onEndReachedThreshold={0.8}
          onRefresh={onPullToRefresh}
          onEndReached={onEndReached}
          ItemSeparatorComponent={Separator}
          ListFooterComponent={() => {
            if (onEndReachedSpinner) {
              return (
                <View style={{ flex: 1, padding: 10, alignItems: 'center' }}>
                  <Spinner size="large" color="$green10" />
                </View>
              );
            }
            return null;
          }}
          ListFooterComponentStyle={{ height: 100 }}
        />
      )}

      {Platform.OS !== 'web' ? (
        <FloatingAction
          onPressMain={navigateToCreateQuestion}
          overlayColor={'transparent'}
          color={theme['qnaFloatingButtonBg']?.val}
          buttonSize={75}
          floatingIcon={
            <YStack alignItems="center" testID="kisan_tId_floatingIcon_askQuestion_click">
              <AskQuestionFlotingIcon width={30} height={30} />
              <Text
                style={{ fontSize: 11, color: '#FFF', fontWeight: '600', textAlign: 'center' }}
                paddingTop={3}
                textTransform="uppercase"
              >
                {t('page.ask')}
              </Text>
            </YStack>
          }
        />
      ) : (
        <CustomPressable
          onPress={navigateToCreateQuestion}
          style={{
            position: 'absolute',
            bottom: 100,
            right: 20,
            width: 75,
            height: 75,
            backgroundColor: theme['qnaFloatingButtonBg']?.val,
            borderRadius: 37.5,
            justifyContent: 'center',
            alignItems: 'center',
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.8,
            shadowRadius: 2,
            elevation: 5,
          }}
        >
          <YStack alignItems="center">
            <AskQuestionFlotingIcon width={30} height={30} />
            <Text
              style={{
                fontSize: 11,
                color: '#FFF',
                fontWeight: '600',
                textAlign: 'center',
                paddingTop: 3,
                textTransform: 'uppercase',
              }}
            >
              {t('page.ask')}
            </Text>
          </YStack>
        </CustomPressable>
      )}
      {langaugeBottomSheet && (
        <UIBottomSheet
          open={langaugeBottomSheet}
          animation={'quick'}
          onOpenChange={setLangaugeBottomSheet}
          snapPoints={[56]}
          children={
            <LanguageFilter
              onFilterChange={handleFilterChange}
              setLangaugeBottomSheet={setLangaugeBottomSheet}
              currentLanguage={languageFilterValue}
            />
          }
        />
      )}
    </YStack>
  );
};
